import { ConfigProvider } from 'antd';
import { ApolloProvider } from '@apollo/client';
import { RouterProvider } from 'react-router-dom';
import { client } from './graphql/client';
import { router } from './routes';
import { defaultTheme } from './theme';
import { UserProvider } from './providers/user';

export function Main() {
  return (
    <ConfigProvider theme={defaultTheme}>
      <ApolloProvider client={client}>
        <UserProvider>
          <RouterProvider router={router} />
        </UserProvider>
      </ApolloProvider>
    </ConfigProvider>
  );
}
